import { computed, defineComponent, inject, ref } from "vue";
import { AppGeneralVariables } from 'src/plugins/general/variables';
import { AppStringMethods } from 'src/plugins/string/stringMethods';
import appMultiColoredIcon from "src/components/icon/appMultiColoredIcon.vue";
export default defineComponent({
    name: "search-browse-btn",
    components: {
        appMultiColoredIcon
    },
    props: {
        btnClass: {
            type: Object,
            default: () => {
                return {
                    'text-primary': true
                };
            }
        },
        mainMenuOffset: {
            type: Array,
            default: () => {
                return [0, 0];
            },
        },
    },
    setup() {
        const { styleType } = AppGeneralVariables();
        const isOwner = inject("isOwner", false);
        const allSearchRoutes = [
            {
                app: "getspaces",
                activated_app_category: "getspaces",
                display_name: "Flexible Rent",
                routerData: {
                    name: "Search",
                    query: { space_charge_type: "normal" },
                }
            }
        ];
        const showMenu = ref(false);
        const searchRoutes = computed(() => {
            const parsedOptions = [];
            const activatedApps = JSON.parse(process.env.activated_apps);
            for (let i = 0; i < allSearchRoutes.length; i++) {
                const appType = allSearchRoutes[i].activated_app_category;
                if (activatedApps.indexOf(appType) > -1) {
                    parsedOptions.push(allSearchRoutes[i]);
                }
            }
            return parsedOptions;
        });
        const { numberWithCommas } = AppStringMethods();
        return {
            styleType,
            isOwner,
            showMenu,
            searchRoutes,
            numberWithCommas,
        };
    },
});
